module.exports = __webpack_public_path__ + "static/media/template.active.8588eb20.svg";